import { SOLD_SERVICE_STATUS } from '@sales-center/common'
import { permissionDenied } from '@user/store/authorization'
import { OPPORTUNITY_STATUSES, OppStatus } from '../OpportunityCard/typings'

export const useReopenStatus = (
  canUpdate: boolean,
  oppStatus: OppStatus,
  soldServiceStatus: SOLD_SERVICE_STATUS,
  hasOnlySystemFields: boolean,
) => {
  const opportunityOpen = oppStatus === OPPORTUNITY_STATUSES.Open
  const reopenDisabled: boolean =
    !canUpdate ||
    opportunityOpen ||
    (!opportunityOpen && soldServiceStatus === 'Completed') ||
    (!opportunityOpen && soldServiceStatus === 'Processing') ||
    (!opportunityOpen && hasOnlySystemFields)
  const tooltipText = !canUpdate
    ? permissionDenied
    : soldServiceStatus === 'Completed'
      ? 'This opportunity cannot be reopened'
      : soldServiceStatus === 'Processing'
        ? 'This opportunity cannot be re-opened because it is currently being processed for service'
        : hasOnlySystemFields
          ? 'This sales funnel does not have any stages other than closed/won and closed/lost.  Create a custom opportunity stage to re-open opportunities in this funnel'
          : undefined

  return { reopenDisabled, tooltipText }
}
